<template>
  <div>
    <el-drawer @reload="$reloadHandle" title="旧机退回" size="30%" :before-close="handleClose" :visible.sync="drawer"
               append-to-body="ture" direction="rtl" :modal-append-to-body="true" custom-class="demo-drawer" ref="drawer">
      <i class="el-icon-info" />
      单据号：<span v-if="exchangeOrderNo" style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{
        exchangeOrderNo }}</span>
      <div class="demo-drawer__content">
        <div id="containt">
          <div class="tab-box">
            <el-form :label-position="right" label-width="80px" ref="editForm" :model="formData">
              <el-form-item label="是否需要退回" >
                <el-radio-group v-model="formData.isNeedBackToSite" @change="changeIsBack">
                  <el-radio  :label="0">否</el-radio>
                  <el-radio  :label="1">是</el-radio>
                </el-radio-group>

              </el-form-item>
              <el-form-item label="物流公司" >
                <el-select v-model="formData.zbBackLogisticsCompanyName" filterable style="width:10vw!important;" :disabled="showWl"
                           clearable>
                  <el-option v-for="item in logisticsCompaniesList" :key="item.value" :label="item.label"
                             :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="物流单号" >
                <el-input type="text" autocomplete="off" v-model="formData.zbBackLogisticsNo" :disabled="showWl"
                          style="width:10vw!important;" clearable />
              </el-form-item>


            </el-form>
          </div>
        </div>
      </div>

      <div class="demo-drawer__content">
        <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary"  @click="siteAppeal">
            确 定
          </el-button>
        </div>
      </div>
    </el-drawer>

  </div>
</template>
<script>
import api from "@/api/projectApi";
import { dictType, loadDictData } from "@/config/dictType";
import orderPop from "@/views/dialogCommon/radioOrderDialog.vue";

export default {
  components: {orderPop},
  inject: ['reload'],
  name: 'edit',
  props: ['multi', 'exchangeOrderNo', 'exchangeOrderId', 'obj'],
  created() {
    this.formData.id = this.exchangeOrderId
  },
  data() {
    return {

      uploadFileUrl: api.uploadFileUrl,
      logisticsCompaniesList: [],

      siteAppealButton: false,
      showWl:false,
      formData: {
        id: null,
        processId: null,
        taskId: null,
        zbBackLogisticsCompanyName: null,
        zbBackLogisticsCompany: null,
        zbBackLogisticsNo: "",
        isNeedBackToSite:null
      },

      showOrderPop: false,

      drawer: true,
    }
  },
  methods: {

    changeIsBack(){
      if (this.formData.isNeedBackToSite==1){
        this.showWl = false;
      }else{
        this.showWl = true;
        this.formData.zbBackLogisticsCompanyName = null;
        this.formData.zbBackLogisticsCompany = null;
        this.formData.zbBackLogisticsNo = null;
      }
    },

    // 旧件退回
    siteAppeal() {
      if (this.formData.isNeedBackToSite ==null) {
        this.$message.error("请选择是否需要退回")
        return
      }
      if (this.formData.isNeedBackToSite == 1) {


        let returnLogisticsCompany = this.formData.zbBackLogisticsCompany
        if (returnLogisticsCompany) {
          this.logisticsCompaniesList.forEach(item => {
            if (returnLogisticsCompany === item.value) {
              this.formData.zbBackLogisticsCompanyName = item.label
            }
          })
        }
      }

        this.$baseConfirm('您确定要保存吗？').then(() => {
          this.$mask.open()
          this.$http({
            url: "/basic/wkExchangeOrder/zbBackMachine",
            method: 'post',
            data: this.formData
          }).then(res => {
            this.$mask.close()
            this.$message.success('确认成功')
            this.$emit('closeDialog',true)
          }).catch(() => {
            this.$mask.close()
          })
        })

    },


    // 加载数据字典中物流公司，运输方式
    loadDictData() {
      // 物流公司
      loadDictData(dictType.logisticsCompanies).then(res => {
        this.logisticsCompaniesList = []
        res.data.data.forEach(item => {
          this.logisticsCompaniesList.push({
            label: item.label,
            value: item.id
          })
        })
      })
    },
    confirm() {
      this.drawer = false;
      this.handleClose()
    },
    cancelForm() {
      this.loading = false;
      this.drawer = false;
      clearTimeout(this.timer);
    },
    handleClose() {

      this.drawer = false;
      this.$emit('closeDialog', false)
    }
  },
  mounted() {
    this.loadDictData()
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer .el-drawer__body {
  padding: 0 16px;
  background-color: #fff;
  position: relative;
}

::v-deep .el-drawer .el-drawer__header {
  background-color: #fff;
}

::v-deep .el-drawer__container {
  position: relative;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background: aliceblue;
  background-color: rgb(38 38 38 / 70%);
}

#containt .table-detail {
  border-collapse: collapse;
  font-size: 12px;
  border: 1px solid #ededed;
}

.btn {
  text-align: center;
}
</style>
